import React, { useMemo } from "react";
import CandleGraphs from "../../../reusableComponents/CandleGraphs/CandleGraphs";
import ReactTable from "../../Table";
import "./ResultTradeDuration.scss";
import { FormatUSD } from "../../../utils/helpers/string";

const ResultTradeDuration = ({ result_by_trade_duration }) => {
  const performance_trade = {
    data:
      result_by_trade_duration?.account_data_analysis?.result_by_trade_duration
        ?.chart?.average_profit_loss ?? [],
    time:
      result_by_trade_duration?.account_data_analysis?.result_by_trade_duration
        ?.chart?.duration ?? [],
  };

  const tableData =
    result_by_trade_duration?.account_data_analysis?.result_by_trade_duration
      ?.data ?? [];

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <div className="header-with-icon">
            <span>Duration</span>
          </div>
        ),
        accessor: "Duration",
        Cell: ({ value }) => (
          <div className="col-wrapper">
            <p>{value}</p>
          </div>
        ),
      },
      {
        Header: () => (
          <div className="header-with-icon">
            <span>No. Of Trades</span>
          </div>
        ),
        accessor: "no_of_trade",
        Cell: ({ value }) => (
          <div className="col-wrapper">
            <p>{value}</p>
          </div>
        ),
      },
      {
        Header: () => (
          <div className="header-with-icon">
            <span>Results</span>
          </div>
        ),
        accessor: "results",
        Cell: ({ value }) => (
          <div className="col-wrapper">
            <p
              className={
                value > 0 ? "positive_value" : value < 0 ? "negative_value" : ""
              }
            >
              {FormatUSD(value)}
            </p>
          </div>
        ),
      },
    ],
    [result_by_trade_duration]
  );

  return (
    <div className="resultTradeDurationMain">
      <div className="profit-in-duration">
        <div className="trade-reports">
          <div className="header_Wrapper">
            <h2 className="component-heading">Average PnL in Duration</h2>
          </div>
          <div className="chart-box-wrapper">
            <div className="tabs-wrapper tabs-1">
              <div className="chart-box">
                <CandleGraphs
                  data={performance_trade}
                  dataSymbol="amount"
                  title="Time"
                  graphType="Profit"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="duration-result">
        <p className="headline">Results by Trade Duration</p>
        <div className="trade-duration">
          <ReactTable columns={columns} data={tableData} variant={2} />
        </div>
      </div>
    </div>
  );
};

export default ResultTradeDuration;
